import React from 'react';

const TeamAnalyticsTab = ({ teamData }) => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-6">Team Analytics</h3>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Team Composition */}
        <div className="bg-white border border-gray-200 rounded-xl p-6">
          <h4 className="text-lg font-semibold mb-4">Team Composition</h4>
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <span className="text-gray-600">Players</span>
              <div className="flex items-center space-x-2">
                <div className="w-24 bg-gray-200 rounded-full h-2">
                  <div className="h-2 rounded-full" style={{backgroundColor: '#e25820', width: `${teamData?.totalMembers ? (teamData?.activePlayers / teamData?.totalMembers) * 100 : 0}%`}}></div>
                </div>
                <span className="font-semibold">{teamData?.activePlayers || 0}</span>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-600">Staff</span>
              <div className="flex items-center space-x-2">
                <div className="w-24 bg-gray-200 rounded-full h-2">
                  <div className="bg-purple-500 h-2 rounded-full" style={{width: `${teamData?.totalMembers ? (teamData?.supervisors / teamData?.totalMembers) * 100 : 0}%`}}></div>
                </div>
                <span className="font-semibold">{teamData?.supervisors || 0}</span>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-600">Total Members</span>
              <div className="flex items-center space-x-2">
                <div className="w-24 bg-gray-200 rounded-full h-2">
                  <div className="bg-blue-500 h-2 rounded-full" style={{width: '100%'}}></div>
                </div>
                <span className="font-semibold">{teamData?.totalMembers || 0}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Team Information */}
        <div className="bg-white border border-gray-200 rounded-xl p-6">
          <h4 className="text-lg font-semibold mb-4">Team Details</h4>
          <div className="space-y-4">
            <div className="text-center">
              <div className="text-3xl font-bold mb-2" style={{color: '#e25820'}}>{teamData?.sport?.charAt(0).toUpperCase() + teamData?.sport?.slice(1) || 'N/A'}</div>
              <p className="text-gray-600">Sport</p>
            </div>
            <div className="grid grid-cols-2 gap-4 text-center">
              <div>
                <div className="text-xl font-bold" style={{color: '#e25820'}}>{teamData?.type || 'N/A'}</div>
                <p className="text-sm text-gray-500">Team Type</p>
              </div>
              <div>
                <div className="text-xl font-bold" style={{color: '#e25820'}}>{teamData?.gender || 'N/A'}</div>
                <p className="text-sm text-gray-500">Gender</p>
              </div>
            </div>
          </div>
        </div>

        {/* Organization Info */}
        <div className="bg-white border border-gray-200 rounded-xl p-6">
          <h4 className="text-lg font-semibold mb-4">Organization</h4>
          <div className="flex items-center space-x-4 mb-4">
            {teamData?.organization?.logo && (
              <img 
                src={teamData.organization.logo} 
                alt={teamData.organization.name}
                className="w-16 h-16 rounded-lg object-cover"
              />
            )}
            <div>
              <h5 className="font-semibold text-lg" style={{color: '#e25820'}}>
                {teamData?.organization?.name || 'Unknown Organization'}
              </h5>
              <p className="text-sm text-gray-500">Parent Organization</p>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-gray-600">Team Founded</span>
              <span className="font-medium">{teamData?.founded || 'N/A'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Unique Name</span>
              <span className="font-medium">@{teamData?.uniqueName || 'N/A'}</span>
            </div>
          </div>
        </div>

        {/* Team Overview */}
        <div className="bg-white border border-gray-200 rounded-xl p-6">
          <h4 className="text-lg font-semibold mb-4">Quick Overview</h4>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600">Team Name</span>
              <span className="font-medium">{teamData?.name || 'N/A'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Active Players</span>
              <span className="font-medium">{teamData?.activePlayers || 0}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Coaching Staff</span>
              <span className="font-medium">{teamData?.supervisors || 0}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Player Ratio</span>
              <span className="font-medium">
                {teamData?.totalMembers ? `${Math.round((teamData?.activePlayers / teamData?.totalMembers) * 100)}%` : '0%'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamAnalyticsTab; 